"use client";

import * as Sentry from "@sentry/nextjs";
import { useSession } from "next-auth/react";
import { useEffect } from "react";

export const SentryTags = () => {
  const session = useSession();

  useEffect(() => {
    if (
      session &&
      session.data?.user &&
      typeof session.data.user.email === "string"
    ) {
      Sentry.setUser({
        id: session.data.user.id,
        email: session.data.user.email,
      });
      Sentry.setTag("email", session.data.user.email);
    }
  }, [session]);

  return <></>;
};
